module.exports = __webpack_public_path__ + "static/media/A (8).5571bd8b.jpg";